import React from 'react';
import { HeartIcon, LeafIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { values } from '../../data/site';
const icons = [UsersIcon, HeartIcon, SparklesIcon, LeafIcon];
export function Valeurs() {
  return <section className="bg-creme py-20 md:py-24" data-id="element-168" data-mp="38m8a96uoxk9a">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-start" data-id="element-169" data-mp="33o6pmhhm9cvp">
        <div data-id="element-170" data-mp="2fykss0opv9qv">
          <h2 className="font-display text-3xl font-bold text-nuit sm:text-4xl" data-id="element-171" data-mp="2fy2m0a4fhd4p">
            Ce qui nous rassemble
          </h2>
          <p className="mt-4 max-w-md text-nuit/70" data-id="element-172" data-mp="2b0t034g8zjlm">
            Une association tenue par des bénévoles, où l’on vient autant pour créer que pour se
            retrouver. Le cercle de notre logo, c’est ce foyer : des talents différents, une même
            lumière.
          </p>
        </div>

        <ul className="grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-173" data-mp="4807sgomqt40">
          {values.map((value, index) => {
          const Icon = icons[index];
          return <li key={value.title} className="flex gap-4" data-id="element-174" data-mp="9a5u7n7w98l" data-mpi={index}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white" style={{
              backgroundColor: value.color
            }} data-id="element-175" data-mp="b4iyzs8yx24">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-176" data-mp="97lu430m2uxv" />
                </span>
                <div data-id="element-177" data-mp="e804vstlkizl">
                  <h3 className="font-display text-lg font-semibold text-nuit" data-id="element-178" data-mp="e6f8dxnq2pz3">{value.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-nuit/70" data-id="element-179" data-mp="3dm3k8a48vh5o">{value.description}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}